import ObjectModelBuilderModel from "./tracked/objectModelBuilderModel";
import IRepo from "../interfaces/repo";
import Repo from "../state/modules/repo";
import Guid from "../helpers/guid";
import ObjectModel from "./objectModel";
import { RelationType } from "./relationType";
import { ConditionalFieldDefinition } from "./conditionalRules/conditionalFieldDefinition";
import ObjectModelConditionalFields from "~/models/objectModels/objectModelConditionalFields";
import ConditionalRuleSetFactory from "~/models/conditionalRules/conditionalRuleSetFactory";
import { Hash } from "~/interfaces/hashInterfaces";
import ObjectModelConditionalRuleSet from "~/models/objectModels/objectModelConditionalRuleSet";
import IConditionalRuleContainer from "~/models/conditionalRules/conditionalRuleContainer";
import { ObjectHelper } from "~/helpers/objectHelper";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import GloballySelected from "../../formability/object_model_builder/store/modules/selected";
import Validatable from "~/mixins/validatable";
import ObjectModelLimitValidation from "./navigableValidations/objectModelLimitValidation";

export default class ObjectModelLimit extends Validatable(ObjectModelBuilderModel) implements IConditionalRuleContainer {
  title: string;
  maximum: number;
  limit_not_reached_message: string;
  limit_reached_message: string;
  limit_conditional_rule_sets: Hash<ObjectModelConditionalRuleSet>;

  // Methods

  addToRepo(): void {
    ObjectModelLimit.repo.add(this);
  }

  select(): void {
    GloballySelected.objectModelLimit.set(this);
  }

  // Validation

  _validation: ObjectModelLimitValidation = new ObjectModelLimitValidation(this);

  getDisplayName(propName: string, value?): string {
    switch (propName) {
      case "title":
        return "Limit Name"
      case "maximum":
        return "Limit Maximum"
      default:
        return propName
    }
  }

  // Embedded Models


  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    const models = {};
    for (const definition of ObjectModelConditionalFields.LIMIT_FIELDS) {
      models[`${definition.fieldName}_conditional_rule_sets`] = { type: ObjectModelConditionalRuleSet, relationType: RelationType.dictionary };
      if (definition.defaultConditionalValue instanceof Function) {
        models[definition.fieldName] = { type: Object, relationType: RelationType.singleObject };
      }
    }
    return models;
  }

  createEmbeddedObject = {};

  // Conditional Rule Sets

  getConditionalRuleSets(fieldName: string): Hash<ObjectModelConditionalRuleSet> {
    return this[`${fieldName}_conditional_rule_sets`];
  }

  getSortedConditionalRuleSets(fieldName: string): ObjectModelConditionalRuleSet[] {
    const ruleSets = this.getConditionalRuleSets(fieldName);
    return ObjectHelper.toArray(ruleSets).sort((x, y) => x.sort_order < y.sort_order ? -1 : 1);
  }

  createNewRuleSet(fieldName: string, definition: ConditionalFieldDefinition): ObjectModelConditionalRuleSet {
    return new ObjectModelConditionalRuleSet(fieldName, definition);
  }

  getReferencedControl(id: string): ObjectModelProperty {
    return ObjectModelProperty.repo.find(id);
  }

  getReferencableControls(): ObjectModelProperty[] {
    return this.rootModel.objectModelPropertiesArray;
  }

  // Class Configurations

  constructor() {
    super();
    this.defineProperty('client_id', Guid.create());
    this.defineProperty('title', "")
    this.defineProperty('maximum', null)
    this.defineProperty('limit_not_reached_message', "")
    this.defineProperty('limit_reached_message', "")

    for (const definition of ObjectModelConditionalFields.LIMIT_FIELDS) {
      const conditionalFieldName = `${definition.fieldName}_conditional_rule_sets`;
      this.except.push(conditionalFieldName);
      this[conditionalFieldName] = {};
      this.createEmbeddedObject[conditionalFieldName] = (parent, json) => {
        return ConditionalRuleSetFactory.createForContainer(this, definition, {}, true, false);
      };
      if (definition.defaultConditionalValue instanceof Function) {
        this.except.push(definition.fieldName);
        this.createEmbeddedObject[definition.fieldName] = definition.defaultConditionalValue;
      }
    }
  }

  initialize(root: ObjectModel, parent: ObjectModel, type: number = 0, json: object = {}): this {
    this.rootModel = root;
    this.parent = parent;
    this.loadFromJson(json);
    return this;
  }

  static repo: IRepo<ObjectModelLimit> = new Repo<ObjectModelLimit>('objectModelLimits', ObjectModelLimit);

  static get rootName(): string {
    return 'object_model_limits';
  }

  get rootName(): string {
    return 'object_model_limits';
  }

  // can(duty: ObjectModelTriggerCapability): boolean {
  //   return ObjectModelTriggerCapabilityManager.can(this.trigger_type, duty);
  // }

}